export default "__VITE_ASSET__D1bVWM8L__"